var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            rules: _vm.rules,
            model: _vm.childData,
            "label-position": "right",
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.deptName"), prop: "deptName" } },
            [
              _c("el-input", {
                staticStyle: { width: "250px" },
                attrs: { maxlength: "20" },
                model: {
                  value: _vm.childData.deptName,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "deptName", $$v)
                  },
                  expression: "childData.deptName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.upDeptName") } },
            [
              _c("el-cascader", {
                staticStyle: { width: "250px" },
                attrs: {
                  clearable: "",
                  options: _vm.options,
                  props: _vm.propstree,
                  "change-on-select": ""
                },
                model: {
                  value: _vm.childData.upIdList,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "upIdList", $$v)
                  },
                  expression: "childData.upIdList"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.deptOrder"), prop: "deptOrder" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "250px" },
                attrs: { min: 1, max: 99, label: "请输入部门排序" },
                model: {
                  value: _vm.childData.deptOrder,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "deptOrder", $$v)
                  },
                  expression: "childData.deptOrder"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.deptDesc"), prop: "deptDesc" } },
            [
              _c("el-input", {
                staticStyle: { width: "250px" },
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 4 }
                },
                on: { change: _vm.handleRemarkInput },
                model: {
                  value: _vm.childData.deptDesc,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "deptDesc", $$v)
                  },
                  expression: "childData.deptDesc"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }